enum PusherConfig {
    PUSHER_CLUSTER = 'eu'
}

export { PusherConfig };